module.exports = __webpack_public_path__ + "img/LogoShadow.fd018058.png";